import { AnimateOnScroll } from 'animate-on-scroll-framer'
import React from 'react'

export default function TOKENOMICS() {
  return (
    <div
      className='md:mt-20 mt-10 relative z-30'
      id='tokenomics'
    >
      <AnimateOnScroll animation='flipIn'>
        <img
          src='/images/testimonic-layar.jpeg'
          alt='testimonic-layar'
          className='absolute top-0 left-0 -z-50 h-[500px] w-full'
        />
      </AnimateOnScroll>

      <div className='grid lg:grid-cols-2 grid-cols-1 gap-10'>
        <div className='flex flex-col justify-between'>
          <div className='space-y-5'>
            <AnimateOnScroll animation='flipIn'>
              <div className='bg-black border border-[#FFFFFF1F] text-[#FF8A3D] text-center rounded-full w-36 py-2 px-5'>
                <h5>TOKENOMICS</h5>
              </div>
            </AnimateOnScroll>
            <AnimateOnScroll animation='flipIn'>
              <h1 className='md:text-5xl text-3xl font-medium '>
                Economic overview of the token
              </h1>
            </AnimateOnScroll>
          </div>
          <div>
            <AnimateOnScroll animation='flipIn'>
              <h3 className='text-[126px] font-semibold text-[#53a7cb] leading-none	'>
                1M
                <span className='text-xl font-light text-white'>
                  $TAI tokens
                </span>
              </h3>
            </AnimateOnScroll>
            <AnimateOnScroll animation='flipIn'>
              <p className='uppercase text-xl'>Total supply</p>
            </AnimateOnScroll>
          </div>
        </div>
        <div className='space-y-10'>
          <div className='flex items-center gap-5'>
            <div>
              <AnimateOnScroll animation='flipIn'>
                <h3 className='text-[126px] font-semibold text-[#53a7cb] leading-none	'>
                  5%
                </h3>
              </AnimateOnScroll>
              <AnimateOnScroll animation='flipIn'>
                <p className='uppercase font-light text-xl text-[#C4C4C4]'>
                  BUY/ SELL TAX
                </p>
              </AnimateOnScroll>
            </div>
            <AnimateOnScroll animation='flipIn'>
              <p clas>ON TRANSACTIONS</p>
            </AnimateOnScroll>
          </div>
          <div className='flex items-center gap-5'>
            <div>
              <AnimateOnScroll animation='flipIn'>
                <h3 className='text-[126px] font-semibold text-[#53a7cb] leading-none	'>
                  1 yr
                </h3>
              </AnimateOnScroll>
              <AnimateOnScroll animation='flipIn'>
                <p className='uppercase font-light text-xl text-[#C4C4C4] mt-3'>
                  Liquidity pOOL
                </p>
              </AnimateOnScroll>
            </div>
            <AnimateOnScroll animation='flipIn'>
              <p>LOCKED</p>
            </AnimateOnScroll>
          </div>
          <div className='flex items-center gap-5'>
            <div>
              <AnimateOnScroll animation='flipIn'>
                <h3 className='text-[126px] font-semibold text-[#53a7cb] leading-none	'>
                  2%
                </h3>
              </AnimateOnScroll>
              <AnimateOnScroll animation='flipIn'>
                <p className='uppercase font-light text-xl text-[#C4C4C4]'>
                  MAXIMUM TRANSACTION
                </p>
              </AnimateOnScroll>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
